"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = getCookie;
exports.getTraceContextFromCookie = void 0;
var _api = require("@opentelemetry/api");
var TRACE_COOKIE_NAME = 'otel-trace-context';
function getCookie(k) {
  var v = document.cookie.match("(^|;) ?".concat(k, "=([^;]*)(;|$)"));
  return v ? v[2] : null;
}
var getTraceContextFromCookie = function getTraceContextFromCookie() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  try {
    var cookieValue = getCookie(TRACE_COOKIE_NAME, options);
    if (cookieValue) {
      var decoded = decodeURIComponent(cookieValue);
      var traceData = JSON.parse(decoded);
      if (Date.now() - traceData.timestamp < 3600000) {
        var carrier = {
          traceparent: traceData.traceparent
        };
        if (traceData.tracestate) {
          carrier.tracestate = traceData.tracestate;
        }
        if (traceData.baggage) {
          carrier.baggage = traceData.baggage;
        }
        return _api.propagation.extract(_api.ROOT_CONTEXT, carrier);
      }
    }
  } catch (error) {
    console.error('Error reading trace context from cookie:', error);
  }
  return _api.context.active();
};
exports.getTraceContextFromCookie = getTraceContextFromCookie;